import React from "react";
import ReactDOM from "react-dom";
import "antd/dist/antd.css";
import "./ExcelShareModal.css";
import { Modal, Input, Form, Button, Select } from "antd";
import ExcelShareForm from "./ExcelShareForm";
import { connect } from "react-redux";

class ExcelShareModal extends React.Component {
  constructor(props) {
    super(props);
    // this.state = {
    //     visible: false,
    //     input: {},
    //     errors: {}
    // }
  }

  render() {
    return (
      <>
        <Modal
          title={"Share Reports"}
          visible={this.props.isOpen}
          onOk={this.props.handleClose}
          onCancel={this.props.handleClose}
          destroyOnClose={true}
          width={"700px"}
          footer={null}
        >
          <ExcelShareForm
            status={this.props.status}
            exportDefaultSubject={this.props.exportDefaultSubject}
            handleClose={this.props.handleClose}
            handleExcelExport={this.props.handleExcelExport}
            validComplianceShareDomains={this.props.validComplianceShareDomains}
          />
        </Modal>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    validComplianceShareDomains:
      state.appPermissionsReducer.compliancePermissions
        .validComplianceShareDomains,
  };
}

export default connect(mapStateToProps)(ExcelShareModal);
